import { render } from "./ExternalImage.vue?vue&type=template&id=e25b95c2"
import script from "./ExternalImage.vue?vue&type=script&lang=js"
export * from "./ExternalImage.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__